function readString(value) {
    return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}
function readNestedUser(raw) {
    const user = raw.user;
    const createdBy = raw.createdBy;
    const username = readString(user?.username) ?? readString(raw.userUsername) ?? readString(createdBy?.username);
    const name = readString(user?.name) ?? readString(createdBy?.name) ?? username;
    if (!name && !username) {
        return undefined;
    }
    const id = user?.id ?? createdBy?.id;
    return {
        id: id != null ? String(id) : undefined,
        name,
        username,
    };
}
function readNestedClosedBy(raw) {
    const closedBy = raw.closedBy;
    const username = readString(closedBy?.username) ??
        readString(raw.closedByUsername) ??
        readString(raw.closedByDisplay);
    const name = readString(closedBy?.name) ?? username;
    if (!name && !username) {
        return undefined;
    }
    const id = closedBy?.id;
    return {
        id: id != null ? String(id) : undefined,
        name,
        username,
    };
}
function readNestedIssue(raw) {
    const issue = raw.issue;
    const issueName = readString(raw.issueName) ?? readString(issue?.name);
    const issueId = issue?.id ?? raw.issueId;
    if (!issueName && issueId == null) {
        return undefined;
    }
    return {
        id: issueId != null ? String(issueId) : undefined,
        name: issueName,
    };
}
function readNestedProvince(raw) {
    const province = raw.province;
    const provinceName = readString(raw.provinceName) ?? readString(province?.name);
    const provinceId = province?.id ?? raw.provinceId;
    if (!provinceName && provinceId == null) {
        return undefined;
    }
    return {
        id: provinceId != null ? String(provinceId) : undefined,
        name: provinceName,
    };
}
function readNestedDistrict(raw) {
    const district = raw.district;
    const districtName = readString(raw.districtName) ?? readString(district?.name);
    const districtId = district?.id ?? raw.districtId;
    if (!districtName && districtId == null) {
        return undefined;
    }
    return {
        id: districtId != null ? String(districtId) : undefined,
        name: districtName,
    };
}
function readPhoneId(raw) {
    const phone = raw.phone;
    const phoneId = raw.phoneId ?? phone?.id;
    if (phoneId == null || phoneId === '')
        return undefined;
    if (typeof phoneId === 'string' || typeof phoneId === 'number')
        return phoneId;
    return undefined;
}
function readPhoneEmail(raw) {
    const phone = raw.phone;
    return readString(phone?.email) ?? readString(raw.customerEmail);
}
function readQueueLogCallId(raw) {
    const queueLog = raw.respondedAgentInQueueLog;
    return readString(queueLog?.callid);
}
function readQueueName(raw) {
    const queueLog = raw.respondedAgentInQueueLog;
    return readString(raw.queueName) ?? readString(queueLog?.queuename);
}
/** Request body for `PATCH /api/kases/{id}`. */
export function buildKasePatchBody(payload) {
    const body = {
        id: Number(payload.caseId),
    };
    if (payload.remark !== undefined)
        body.remark = payload.remark;
    if (payload.subject !== undefined)
        body.subject = payload.subject;
    if (payload.issueId)
        body.issueId = Number(payload.issueId);
    if (payload.provinceId)
        body.provinceId = Number(payload.provinceId);
    if (payload.districtId)
        body.districtId = Number(payload.districtId);
    if (payload.branchName !== undefined)
        body.branchName = payload.branchName;
    return body;
}
/** Normalize `KaseDTO` list/detail payloads for panel UI models. */
export function mapKaseDtoToPanelCase(raw) {
    const row = (raw ?? {});
    const user = row.user;
    return {
        ...row,
        issue: readNestedIssue(row),
        province: readNestedProvince(row),
        district: readNestedDistrict(row),
        createdBy: readNestedUser(row),
        user: user?.name
            ? { id: user.id != null ? String(user.id) : undefined, name: user.name }
            : row.user,
        callDuration: typeof row.callDuration === 'number' ? row.callDuration : undefined,
        callStatus: readString(row.callStatus),
        hangupBy: readString(row.hangupBy),
        uniqueId: readString(row.uniqueId) ?? readString(row.callid) ?? readQueueLogCallId(row),
        callid: readString(row.callid) ?? readString(row.uniqueId) ?? readQueueLogCallId(row),
        phoneId: readPhoneId(row),
        customerId: readPhoneId(row) ?? row.customerId,
        customerEmail: readPhoneEmail(row),
        socialMedia: readString(row.socialMedia),
        queueName: readQueueName(row),
        queueType: readQueueName(row) ?? readString(row.queueType),
        lastUpdateDate: readString(row.lastUpdateDate),
        closedBy: readNestedClosedBy(row),
        closedOn: readString(row.closedOn),
    };
}
export function mapKaseDtoToTicketDetail(raw) {
    return mapKaseDtoToPanelCase(raw);
}
export function mapKaseDtoList(rows) {
    return rows.map((row) => mapKaseDtoToPanelCase(row));
}
